import React, { useCallback } from "react";
import moment from "moment-timezone";

import { DataInAnyRow } from "components/PageDashboard/ExternalCommitmentsSection/ExternalCommitmentsTable/ExternalCommitmentsTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import { getDateFromSelection } from "components/FieldDate/FieldDateSelection";
import StepTime from "components/PageDashboard/StepTime";

function StepTimeTo({
	wizardData,
	...rest
}: ModalWizardStepRenderProps<DataInAnyRow>) {
	const {
		dateStartsInRowTimezone,
		timeStartsInRowTimezone,
		dateEndsJustBeforeInRowTimezone,
		timezone
	} = wizardData;

	const checkDisabled = useCallback(
		(time: number) => {
			if (dateStartsInRowTimezone === undefined) {
				return false;
			}
			if (timeStartsInRowTimezone === undefined) {
				return false;
			}
			if (dateEndsJustBeforeInRowTimezone === undefined) {
				return false;
			}

			if (timezone === undefined) {
				return false;
			}

			const dateTimeStarts = moment(
				getDateFromSelection(dateStartsInRowTimezone, timezone)
			)
				.hours(timeStartsInRowTimezone.hours())
				.startOf("hour");

			const thisDateTime = moment(
				getDateFromSelection(dateEndsJustBeforeInRowTimezone, timezone)
			)
				.hours(time)
				.startOf("hour");

			return thisDateTime.isSameOrBefore(dateTimeStarts);
		},
		[
			dateStartsInRowTimezone,
			timeStartsInRowTimezone,
			dateEndsJustBeforeInRowTimezone,
			timezone
		]
	);

	return (
		<StepTime
			wizardData={wizardData}
			wizardKey="timeEndsJustBeforeInRowTimezone"
			checkDisabled={checkDisabled}
			{...rest}
		/>
	);
}

export default StepTimeTo;
